import { useEffect, useMemo, useState } from 'react'
import { PurchaseOrder } from '../../../state/types'
import { PurchasePDF } from '../purchase-pdf/purchasePDF'
import { DownloadFilesModal, fileHelpers, fileNameFromUrl, FileOption } from '../../../../../features/files'
import { Ticket, useTicketLoaders } from '../../../../administration'
import { operationHelpers } from '../../../../operations'
import { Delivery, DeliveryNotesFileOptions, DeliveryOrder, useDeliveryLoaders, useDeliveryOrderLoaders } from '../../../../deliveries'

type Props = {
    purchase?: PurchaseOrder
}

export const DownloadPurchaseFilesModal = (props: Props) => {
    const { purchase } = props

    const [deliveries, setDeliveries] = useState<Delivery[]>([])
    const [deliveryOrders, setDeliveryOrders] = useState<DeliveryOrder[]>([])
    const [tickets, setTickets] = useState<Ticket[]>([])

    const { describeCode } = operationHelpers
    const { purchaseFileName } = fileHelpers

    const deliveryLoaders = useDeliveryLoaders()
    const deliveryOrderLoaders = useDeliveryOrderLoaders()
    const ticketLoaders = useTicketLoaders()

    useEffect(() => {
        if (purchase) {
            deliveryLoaders().loadOperationDeliveries(purchase.id).then(setDeliveries)
            deliveryOrderLoaders().loadOperationDeliveryOrders(purchase.id).then(setDeliveryOrders)
            ticketLoaders().loadParentTickets(purchase.id).then(setTickets)
        }
    }, [purchase])

    const deliveryNotesFileOptions = DeliveryNotesFileOptions({ deliveries, deliveryOrders })

    const fileOptions = useMemo(() => {
        if (!purchase) return []
        
        const options: FileOption[] = []

        options.push({
            id: 'order-pdf',
            label: `Orden de Compra ${describeCode(purchase)}`,
            fileName: purchaseFileName(purchase.code),
            pdf: {
                id: 'order-pdf',
                component: <PurchasePDF id="order-pdf" purchase={purchase} />
            }
        })

        tickets.forEach(ticket => {
            options.push({
                id: `ticket-${ticket.code}`,
                label: `Factura #${ticket.code}`,
                fileName: fileNameFromUrl(ticket.ticketUrl)!,
                url: ticket.ticketUrl
            })
        })

        if (deliveryNotesFileOptions.length > 0) {
            options.push(...deliveryNotesFileOptions)
        }

        return options
    }, [purchase, tickets, deliveryNotesFileOptions])

    return <DownloadFilesModal fileOptions={fileOptions} />
}
